<template>
  <div class="c-tagger">
    <Row class="c-input-box">
      <Col span="24">
        <Input v-model="inputTagValue" placeholder="多个关键词用空格隔开，单个词不超过30个字符，汉字占2个字符" @on-blur="inputTrim">
          <span slot="append" class="c-btn-add" @click="add">添加</span>
        </Input>
      </Col>
    </Row>
    <Row class="c-input-box">
      <Col span="24" v-if="err || err1" class="c-tags-err">
        <span v-if="err">单个标签长度不超过15个汉字</span>
        <span v-if="err1">单次添加标签最多1000个</span>
      </Col>
    </Row>
  </div>
</template>
<script>
import { isArray, trim, getByteLen } from '@/common/js/utils'
export default {
  name: 'tagger',
  methods: {
    inputTrim() {
      this.inputTagValue = trim(this.inputTagValue)
      this.err = false
      this.err1 = false
    },
    add() {
      let tags
      // 为空
      if (!this.inputTagValue) {
        this.err = true
        return
      }

      tags = this.inputTagValue.split(' ')
      tags = tags.filter((ret) => ret)
      const valid = tags.some((ret) => getByteLen(ret) > 30)

      if (valid) {
        this.err = true
        return
      }

      if (isArray(tags)) {
        if (tags.length > 1000) {
          this.err1 = true
          return
        }
        tags = tags.map((ret, id) => {
          return {
            id,
            name: ret
          }
        })
        this.$emit('on-add', tags)
        this.inputTagValue = ''
        this.err = false
        this.err1 = false
      }
    }
  },
  data() {
    return {
      err: null,
      err1: null,
      inputTagValue: ''
    }
  }
}
</script>
<style lang='scss' scoped>
.c-tagger {
  display: block;

  .c-input-box {
    padding: 0 6px 10px 6px;
    position: relative;

    .c-btn-add {
      padding: 0 8px;
    }
  }

  .c-tags-err {
    margin-top: 10px;
    font-size: 14px;
    line-height: 28px;
    color: red;

    span {
      display: block;
    }
  }
}
</style>
